export default __webpack_public_path__ + "static/media/05_RoweOil-Commercial-EschweilerPhotography_M1A0246_flat_Shadows.f15d02d6.jpg";